const truthyValues = new Set(['true', '1', 'yes', 'on']);

function readEnvFlag(value) {
  if (!value) return false;
  return truthyValues.has(String(value).toLowerCase());
}

export const AUTH_BYPASS_DEV =
  process.env.NODE_ENV === 'development' &&
  (readEnvFlag(process.env.REACT_APP_AUTH_BYPASS_DEV) ||
    readEnvFlag(process.env.REACT_APP_DF8_AUTH_BYPASS_DEV));

const allowedSignupModes = new Set(['INVITE_ONLY', 'OPEN']);
const rawSignupMode = (process.env.REACT_APP_SIGNUP_MODE || '').toUpperCase();
export const SIGNUP_MODE = allowedSignupModes.has(rawSignupMode)
  ? rawSignupMode
  : 'INVITE_ONLY';
